export enum EEthnicity {
  HISPANIC = 'Hispanic/Latino',
  NON_HISPANIC = 'Not Hispanic/Latino',
  DECLINE = 'Decline to Respond'
}
